<template>
    <div class="contain">
        <div class="info">
            <div class="left">
                <ul>
                    <li>
                        <div>
                            <img src="../assets/logo.png" />
                        </div>
                        <h3>沈阳契合科技有限公司</h3>
                        <p>公司电话：400-000-5560</p>
                        <p>商务合作：service@qihe-cloud.com</p>
                    </li>
                </ul>
            </div>
            <div class="right">
                <ul>
                    <li v-for="(item, index) in List" :key="index">
                        <h3>{{ item.title }}</h3>
                        <a
                            v-for="(items, indexs) in item.cunst"
                            :key="indexs"
                            @click="btnPath(items.path)" style="cursor: pointer;"
                            >{{ items.name }}</a
                        >
                    </li>
                    <li>
                        <h3>技术服务</h3>
                        <a>社交营销</a>
                        <a>客户数据平台</a>
                        <a>营销自动化</a>
                        <a>活动管理</a>
                    </li>
                    <li>
                        <h3>解决方案</h3>
                        <a>全渠道获客</a>
                        <a>企业私域流量</a>
                        <a>线索精细化培育</a>
                        <a>构建营销闭环</a>
                    </li>
                    <li>
                        <h3>客户案例</h3>
                        <a>建设银行</a>
                        <a>工商银行</a>
                        <a>中国银行</a>
                        <a>兴业银行</a>
                        <a>招商银行</a>
                    </li>
                    <li class="last">
                        <h3>关于我们</h3>
                        <a
                            ><img
                                src="../assets/code.png"
                                alt="微信公众号"
                        /></a>
                        <p>更多精彩请关注</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="hr"></div>
        <div class="p">
            Copyright  2019-2024 Qihe-Cloud 沈阳契合科技有限公司 版权所有:
            <!-- <a href="https://beian.miit.gov.cn/">辽ICP备14018473号-2</a> -->
            <a href="https://beian.miit.gov.cn/">辽ICP备14018473号-7</a>
            <!-- <a href="https://beian.miit.gov.cn/">辽ICP备14018473号-1</a> -->
        </div>
        <!---->
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            List: [
                {
                    title: "契合科技产品",
                    cunst: [
                        {
                            name: "首页",
                            path: "/",
                        },
                        {
                            name: "数字智能SCRM",
                            path: "/scrm",
                        },
                        {
                            name: "精选案例",
                            path: "/caseList",
                        },
                        {
                            name: "关于我们",
                            path: "/about",
                        }
                    ],
                },
            ],
        };
    },
    mounted() {
        var that = this;
        // this.common.mounted(that);
    },
    methods: {
        nolond() {},
        btnPath(path) {
            this.$router.push({
                path: path,
            });
        },
    },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/contain.vue